import { defineMessages } from 'react-intl';

export const reorderOrderLineItemMessages = defineMessages({
  successfulReorderMessage: {
    defaultMessage: '{quantity}x {product} added to your bag!',
    description: 'Reorder | Successful reorder message',
  },
});
